import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDsjpdE0Jv_6G7yRKVsQ-0-Cwj2h6hZ_fQ",
  authDomain: "dealswapify.firebaseapp.com",
  projectId: "dealswapify",
  storageBucket: "dealswapify.firebasestorage.app",
  messagingSenderId: "167141808318",
  appId: "1:167141808318:web:821c10e6d78554711e66ef"
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

export const generateToken = async () => {
  if (
    typeof window === "undefined" ||
    !("Notification" in window)
  ) {
    return null;
  }

  let permission = Notification.permission;

  if (permission === "default") {
    permission = await Notification.requestPermission();
  }

  if (permission !== "granted") {
    return null;
  }

  return getToken(messaging, {
    vapidKey: "BHb3RCL09vIBysWNevwYFg_lUuILadqCIMzeTk96DtIBJpSzTw_4ETr0cSHj4_JT37k7xQ5PU2S42KU6m0SDCf4",
  });
};
